import React from 'react';

import { toDDHHMMSS } from '../../Util/Util';

const progressBarH = (props) => {
    let classOrden = 'normal';
    let classDespacho = 'normal';
    let classFactura = 'normal';
    let classRuta = 'normal';

    if (props.tiempos.Orden && props.tiempos.Orden !== 0) {
        classOrden = props.tiempos.EstadoOrden;
    }

    if (props.tiempos.Despacho && props.tiempos.Despacho !== 0) {
        classDespacho = props.tiempos.EstadoDespacho;
    }

    if (props.tiempos.Factura && props.tiempos.Factura !== 0) {
        classFactura = props.tiempos.EstadoFactura;
    }

    if (props.tiempos.Ruta && props.tiempos.Ruta !== 0) {
        classRuta = props.tiempos.EstadoRuta;
    }

    return (
        <ul className="timeline" id="timeline">

            <li className={"li " + classOrden}>
                <div className="timestamp">
                    <span className="author">Orden</span>
                </div>
                <div className="status">
                    <h4> {props.tiempos.Orden !== 0 ? toDDHHMMSS(props.tiempos.Orden) : '00:00:00'}</h4>
                </div>
            </li>
            <li className={"li " + classDespacho}>
                <div className="timestamp">
                    <span className="author">Despacho</span>
                </div>
                <div className="status">
                    <h4>{props.tiempos.Despacho !== 0 ? toDDHHMMSS(props.tiempos.Despacho) : '00:00:00'}</h4>
                </div>
            </li>
            <li className={"li " + classFactura}>
                <div className="timestamp">
                    <span className="author">Factura</span>
                </div>
                <div className="status">
                    <h4>{props.tiempos.Factura !== 0 ? toDDHHMMSS(props.tiempos.Factura) : '00:00:00'}</h4>
                </div>
            </li>
            <li className={"li " + classRuta}>
                <div className="timestamp">
                    <span className="author">Ruta</span>
                </div>
                <div className="status">
                    <h4>{props.tiempos.Ruta !== 0 ? toDDHHMMSS(props.tiempos.Ruta) : '00:00:00'}</h4>
                </div>
            </li>
        </ul>
    )
};

export default progressBarH;